import React from 'react';
import HeroTwo from '../components/heroTwo/HeroTwo';
import './blog.css';
import pythonAdvance from '../assets/python-advance.png';
import { Link } from 'react-router-dom';
import boy from '../assets/boy.jpg'
import scratch from '../assets/scratch-intermediate.png'


export default function Blog() {
    return (
        <div className='blog__container'>
            <HeroTwo 
            head='Blog'
            />
            <div className="blog__main">
                <Link to='/blog-1'>
                <div className="blog__body">
                    <div className="blog__top">
                        <div className="blog__img">
                            <img src={boy} alt="" />
                        </div>
                        
                    </div>
                    <div className="blog__text">

                        <h2>WHY SHOULD I INTRODUCE MY CHILD TO COMPUTER PROGRAMMING AT A YOUNG AGE?</h2>
                        <p className='span'>Computer Programming helps your child develop computational thinking skills at an early age. Computational thinking (CT) is one of the key 21st century skills and involves understanding a problem, designing a solution and expressing it in a form that a human or a machine can execute.</p>
                    </div>
                    

                </div>
                </Link>
                <Link to='/blog-2'>
                <div className="blog__body">
                    <div className="blog__top">
                        <div className="blog__img">
                            <img src={scratch} alt="" />
                        </div>
                        
                    </div>
                    <div className="blog__text">

                        <h2>WHAT IS SCRATCH?</h2>
                        <p className='span'>Scratch was designed at the famous Lifelong Kindergarten Group at the MIT Media Lab, which pioneered the whole idea of teaching programming to kids in the early 1980s through their first kid-friendly language called Logo. It requires kids to drag and drop blocks as if they are building Lego blocks.   </p>
                    </div>
                    

                </div>
                </Link>
                <Link to='/blog-3'>
                <div className="blog__body">
                    <div className="blog__top">
                        <div className="blog__img">
                            <img src={pythonAdvance} alt="" />
                        </div>
                        
                    </div>
                    <div className="blog__text">

                        <h2>TECHNOLOGY BORN GENERATION</h2>
                        <p className='span'>“Can you help me check where to change the camera settings on this phone. I want to be able to set a timer?” Mummy asked Fola her 7-year-old son. “Sure mum”. Within a few minutes, mummy’s issue had been resolved.  </p>
                    </div>
                    

                </div>
                </Link>
            </div>

        </div>
    )
}
